import RoofProtection from "@/components/site/RoofProtection";
import ProductionGuarantee from "@/components/site/ProductionGuarantee";
import FAQSection from "@/components/site/FAQSection";
import InstallationTimeline from "@/components/site/InstallationTimeline";
import ContactJeremy from "@/components/site/ContactJeremy";
import PageMeta from "@/components/site/PageMeta";

export default function HomeownerQuestionsPage() {
  return (
    <main className="pt-24 md:pt-32" data-testid="homeowner-questions-page">
      <PageMeta
        title="Virginia Solar FAQs | Roof, Warranty & Moving"
        description="Virginia homeowner questions answered: roof workmanship warranty, 25-year production guarantee, insurance under the PPA, moving or selling your home, and the seven-step installation process."
      />
      <section className="pb-6 md:pb-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="eyebrow">Homeowner Questions</div>
          <h1 className="mt-3 font-serif-display text-4xl sm:text-5xl lg:text-6xl font-semibold text-[#0F382C] max-w-4xl">
            Roof. Warranty. Move. Insurance. Answered.
          </h1>
          <p className="mt-5 max-w-2xl text-lg text-slate-600">
            The questions Virginia homeowners actually ask — with qualified answers and clear links to the agreement language.
          </p>
        </div>
      </section>
      <RoofProtection />
      <ProductionGuarantee />
      <FAQSection />
      <InstallationTimeline />
      <ContactJeremy />
    </main>
  );
}
